"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
const statsData = [{
  value: "19,000",
  label: "Community Members"
}, {
  value: "5,300",
  label: "Job Applicants"
}, {
  value: "7%",
  label: "Workforce Turnover Rate"
}, {
  value: "15%",
  label: "Workforce Conversion Rate"
}];
const comparisonData = ["15% onboarding conversion rate compared to industry average of 7%", "7% active user turnover rate, compared to service jobs sector avg. 40%"];
export default function FifteenThousandJobsFilled() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: isFooterVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="15000-jobs-filled" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-muted-foreground text-sm font-medium tracking-wider uppercase mb-4 block">
            How It Works
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tight">
            15,000+ Jobs Filled
          </h2>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full mb-20 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {statsData.map((stat, i) => <Card key={i} data-index={i} className="bg-card border-none shadow-xl hover:shadow-2xl transition-shadow duration-300 py-8">
              <CardContent className="px-6 flex flex-col items-center justify-center text-center h-full">
                <span className="text-4xl md:text-5xl font-bold text-foreground mb-3 block">
                  {stat.value}
                </span>
                <span className="text-muted-foreground text-sm font-medium">
                  {stat.label}
                </span>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div ref={footerRef} className={`flex flex-col gap-3 text-center max-w-3xl mx-auto transition-all duration-700 ease-out delay-400 ${isFooterVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {comparisonData.map((text, i) => <p key={i} data-index={i} className="text-muted-foreground text-sm leading-relaxed">
              {text}
            </p>)}
        </div>
      </div>
    </section>;
}